<template>
  <div class="main-wrapper-container create-client-logo-page">
    <header-title :main-title="pageTitle" />
    <title-slot title="Название" />
    <input-main
      :value="form.name"
      :info-input="{ placeholder: 'Введите название' }"
      @changeValue="v => form.name = v.value"
    />

    <title-slot title="Логотип" />
    <file-input
      :file="defaultFileInput"
      :active-file="form.logo"
      :is-active-img="true"
      @removeFile="form.logo = null"
      @changeFile="(value, file, fileSrc) => form.logo = { file, fileSrc }"
    />

    <title-slot title="Ссылка (необязательно)" />
    <input-main
      :value="form.siteUrl"
      :info-input="{ placeholder: 'https://example.com' }"
      @changeValue="v => form.siteUrl = v.value"
    />

    <title-slot title="Сортировка" />
    <input-main
      :value="form.sortOrder"
      :info-input="{ placeholder: '0', type: 'number' }"
      @changeValue="v => form.sortOrder = v.value"
    />

    <button-main @click="saveLogo" :disabled="isDisabledButton">
      {{ isEditMode ? 'Сохранить изменения' : 'Создать логотип' }}
    </button-main>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import HeaderTitle from '@/components/entities/HeaderTitle.vue';
import TitleSlot from '@/components/entities/TitleSlot.vue';
import InputMain from '@/components/shared/input/InputMain.vue';
import ButtonMain from '@/components/shared/buttons/ButtonMain.vue';
import FileInput from '@/components/shared/input/FileInput.vue';
import { api } from "@/middleware/api";

export default {
  name: 'ClientLogoForm',
  components: { FileInput, TitleSlot, HeaderTitle, InputMain, ButtonMain },
  data() {
    return {
      form: {
        id: null,
        name: '',
        siteUrl: '',
        sortOrder: '0',
        logo: null,
      },
      defaultFileInput: {
        placeholder: "Загрузить логотип клиента",
        mimetype: 'image/png, image/jpeg, image/jpg, image/svg+xml',
        mimeTypeString: 'PNG, JPEG, JPG, SVG',
        size: 0.0035,
        title: 'Загрузите файл до 3.5 МБ',
      },
    };
  },
  computed: {
    ...mapGetters('clientLogos', ['getById']),
    ...mapState('clientLogos', ['clientLogos']),
    isDisabledButton() {
      return !this.form.name.trim() || !this.form.logo;
    },
    isEditMode() {
      return !!this.$route.params.id;
    },
    pageTitle() {
      return this.isEditMode ? 'Редактировать логотип' : 'Новый логотип клиента';
    },
  },
  watch: {
    clientLogos() {
      this.prepareData();
    },
  },
  created() {
    this.prepareData();
  },
  methods: {
    ...mapActions('clientLogos', ['addClientLogo', 'updateClientLogo']),
    getClientLogoPayload(includeEmptySiteUrl = false) {
      const siteUrl = this.form.siteUrl?.trim();
      return {
        name: this.form.name,
        ...(siteUrl ? { siteUrl } : includeEmptySiteUrl ? { siteUrl: null } : {}),
        sortOrder: this.form.sortOrder,
      };
    },
    prepareData() {
      if (this.isEditMode) {
        const logo = this.getById(this.$route.params.id);
        if (logo) {
          this.form = {
            ...logo,
            logo: { logoKey: logo.logoKey },
            sortOrder: String(logo.sortOrder || 0),
          };
        }
      }
    },
    async saveLogo() {
      if (this.isEditMode) {
        try {
          if (!this.form.logo?.logoKey) {
            await api.dashboard.adminClientLogosControllerUpdateLogo(
              this.form.id,
              { logo: this.form.logo.file },
            );
          }
          const { data: updated } = await api.dashboard.adminClientLogosControllerUpdate(
            this.form.id,
            this.getClientLogoPayload(true),
          );
          this.updateClientLogo(updated);
          this.alertSuccess('Изменения сохранены!');
          this.$router.push({ name: 'client-logos' });
        } catch (e) {
          console.log('Error updateClientLogo', e);
        }
      } else {
        try {
          const { data } = await api.dashboard.adminClientLogosControllerCreate({
            logo: this.form.logo.file,
            ...this.getClientLogoPayload(),
          });
          this.addClientLogo(data);
          this.alertSuccess('Логотип добавлен!');
          this.$router.push({ name: 'client-logos' });
        } catch (e) {
          this.alertError('Ошибка при создании');
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.create-client-logo-page {
  max-width: 500px;
  .input-container, .input-file-img-container {
    height: 300px;
    width: 300px;
  }
}
</style>
